import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const AgamaService = {}
AgamaService.getDataAll = function (token) {

    return fetch({
        url: '/ref/agama',
        method: 'get',
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

AgamaService.getDataByID = function (token,id) {

    return fetch({
        url: '/ref/agama',
        method: 'get',
        params: {
            "id_agama":id
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

export default AgamaService;
